import { createSlice } from '@reduxjs/toolkit';

const STORAGE_KEY = 'storefront_cart_v2';

function loadFromStorage() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const items = JSON.parse(raw);
      if (Array.isArray(items)) {
        const totalQuantity = items.reduce((s, i) => s + i.quantity, 0);
        const totalAmount = items.reduce((s, i) => s + i.price * i.quantity, 0);
        return { items, totalQuantity, totalAmount };
      }
    }
  } catch (_) {}
  return { items: [], totalQuantity: 0, totalAmount: 0 };
}

function saveToStorage(items) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch (_) {}
}

function recalc(state) {
  state.totalQuantity = state.items.reduce((s, i) => s + i.quantity, 0);
  state.totalAmount = state.items.reduce((s, i) => s + i.price * i.quantity, 0);
}

const { items: initItems, totalQuantity: initQty, totalAmount: initAmount } = loadFromStorage();

const cartSlice = createSlice({
  name: 'cart',
  initialState: {
    items: initItems,
    totalQuantity: initQty,
    totalAmount: initAmount,
    isOpen: false,
  },
  reducers: {
    addToCart: (state, action) => {
      const { dress, size, variantId = null, quantity = 1 } = action.payload;
      const existing = state.items.find(i => i.id === dress.id && i.size === size);
      if (existing) {
        existing.quantity += quantity;
      } else {
        state.items.push({
          id: dress.id,
          name: dress.name,
          price: dress.price,
          image: dress.image,
          category: dress.category || '',
          subCategory: dress.subCategory || '',
          originalPrice: dress.originalPrice || null,
          size,
          variantId,
          quantity,
        });
      }
      recalc(state);
      saveToStorage(state.items);
    },
    removeFromCart: (state, action) => {
      const { id, size } = action.payload;
      state.items = state.items.filter(i => !(i.id === id && i.size === size));
      recalc(state);
      saveToStorage(state.items);
    },
    updateQuantity: (state, action) => {
      const { id, size, quantity } = action.payload;
      const item = state.items.find(i => i.id === id && i.size === size);
      if (item && quantity > 0) {
        item.quantity = quantity;
        recalc(state);
        saveToStorage(state.items);
      }
    },
    clearCart: (state) => {
      state.items = [];
      state.totalQuantity = 0;
      state.totalAmount = 0;
      saveToStorage([]);
    },
    toggleCart: (state) => {
      state.isOpen = !state.isOpen;
    },
    openCart: (state) => {
      state.isOpen = true;
    },
    closeCart: (state) => {
      state.isOpen = false;
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  updateQuantity,
  clearCart,
  toggleCart,
  openCart,
  closeCart,
} = cartSlice.actions;

export const selectCartItems = (state) => state.cart.items;
export const selectCartTotalQuantity = (state) => state.cart.totalQuantity;
export const selectCartTotalAmount = (state) => state.cart.totalAmount;
export const selectCartIsOpen = (state) => state.cart.isOpen;

export default cartSlice.reducer;
